
import vue from '../../../adapter-vue';
import TOAST_TYPE from './type';
import { isPC } from '../../../utils/env';
const { onMounted, ref } = vue;

export default {
  props: {
    message: {
      type: String,
      default: '',
    },
    duration: {
      type: Number,
      default: 1000,
    },
    type: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const visible = ref(false);
    let timer: any;
    const startTimer = () => {
      if (props.duration > 0) {
        timer = setTimeout(() => {
          if (visible.value) {
            close();
            timer && clearTimer();
          }
        }, props.duration);
      }
    };

    const clearTimer = () => {
      clearTimeout(timer);
    };

    const close = () => {
      visible.value = false;
    };

    onMounted(() => {
      startTimer();
      visible.value = true;
    });

    const handleStyle = (type?: string) => {
      if (
        type
          && (type === TOAST_TYPE.ERROR
          || type === TOAST_TYPE.SUCCESS
          || type === TOAST_TYPE.WARNING)
      )
        return type;
      return TOAST_TYPE.NORMAL;
    };
    return {
      props,
      visible,
      handleStyle,
      close,
      clearTimer,
      startTimer,
      isPC,
    };
  },
};
